import React from "react";

const Privacy = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Privacy Policy</h1>
      <p>
        This Privacy Policy applies to the Manzanos PopShop mobile application
        ("Application") created by devzano ("Service Provider") as an ad-supported
        service. The Application is provided for use "AS IS."
      </p>

      <h2>Information Collection and Use</h2>
      <p>
        The Application collects certain information automatically when you
        download and use it. This information may include:
      </p>
      <ul>
        <li>Your device's Internet Protocol (IP) address</li>
        <li>Pages you visit within the Application, along with the time and date of your visit</li>
        <li>Time spent on each page and overall time spent on the Application</li>
        <li>The operating system used on your mobile device</li>
      </ul>
      <p>
        The Application does not collect precise location data from your mobile
        device. However, it does gather approximate location information to:
      </p>
      <ul>
        <li>
          <strong>Geolocation Services:</strong> Offer personalized content, relevant
          recommendations, and location-based services.
        </li>
        <li>
          <strong>Analytics and Improvements:</strong> Use aggregated and anonymized
          location data to analyze user behavior, identify trends, and enhance
          the overall performance and functionality of the Application.
        </li>
        <li>
          <strong>Third-Party Services:</strong> Occasionally transmit anonymized location
          data to external services to help improve the Application and optimize
          the offerings.
        </li>
      </ul>
      <p>
        The Service Provider may also use the information you provide to contact
        you with important information, required notices, or marketing
        promotions.
      </p>
      <p>
        For an enhanced user experience, the Application may require you to
        provide certain personally identifiable information, such as your email
        address (e.g., rmanzano.se@gmail.com). This information will be retained
        and used as described in this Privacy Policy.
      </p>

      <h2>Third-Party Access</h2>
      <p>
        Only aggregated and anonymized data is shared with external services to
        help improve the Application and related services. The Service Provider
        may share your information with third parties as described in this
        privacy statement.
      </p>
      <p>
        Please note that the Application uses third-party services that have
        their own privacy policies regarding data handling. Below are links to
        the privacy policies of these third-party service providers:
      </p>
      <ul>
        <li>AdMob</li>
      </ul>

      <h2>Disclosure of Information</h2>
      <p>
        The Service Provider may disclose information provided by users or
        collected automatically:
      </p>
      <ul>
        <li>As required by law, such as to comply with a subpoena or similar legal process</li>
        <li>When they believe in good faith that disclosure is necessary to protect their rights, your safety or the safety of others, investigate fraud, or respond to a government request</li>
        <li>To trusted service providers who work on their behalf, provided they adhere to the terms set forth in this privacy statement</li>
      </ul>

      <h2>Opt-Out Rights</h2>
      <p>
        You can stop all information collection by the Application easily by
        uninstalling it. Use the standard uninstall processes available as part
        of your mobile device or through the application marketplace or network.
      </p>

      <h2>Data Retention Policy</h2>
      <p>
        The Service Provider will retain user-provided data as long as you use
        the Application and for a reasonable time thereafter. If you wish to
        delete data you have provided via the Application, please contact the
        Service Provider at rmanzano.se@gmail.com, and they will respond within a
        reasonable timeframe.
      </p>

      <h2>Children's Privacy</h2>
      <p>
        The Service Provider does not knowingly collect personally identifiable
        information from children under 13 years of age. The Application is not
        intended for use by children under 13. If the Service Provider discovers
        that a child under 13 has provided personal information, they will
        immediately delete this information from their servers. If you are a
        parent or guardian and you believe your child has provided personal
        information, please contact the Service Provider at
        rmanzano.se@gmail.com so that they can take the necessary actions.
      </p>

      <h2>Security</h2>
      <p>
        The Service Provider is committed to protecting the confidentiality of
        your information. They implement physical, electronic, and procedural
        safeguards to protect the information processed and maintained by the
        Application.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        This Privacy Policy may be updated periodically. The Service Provider
        will notify you of any changes by posting the updated Privacy Policy on
        this page. You are encouraged to review this Privacy Policy regularly, as
        continued use of the Application signifies your acceptance of any
        changes.
      </p>

      <h2>Your Consent</h2>
      <p>
        By using the Application, you consent to the processing of your
        information as outlined in this Privacy Policy, including any future
        amendments.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or the
        Application’s data practices, please contact the Service Provider via
        email at rmanzano.se@gmail.com.
      </p>
    </div>
  );
};

export default Privacy;